const eventType = {
  //SWIPE events
  SWIPE_READY: 'swipe.ready',
  SWIPE_OPEN: 'swipe.open',
  SWIPE_CLOSED: 'swipe.closed',
  SWIPE_GAMECHANGE: 'swipe.gameChanged',
  SWIPE_ERROR: 'swipe.error',

  SWIPE_DRAWER_OPEN: 'swipe.drawer.open',
  SWIPE_DRAWER_CLOSED: 'swipe.drawer.closed',
  SWIPE_DRAWER_GAMECHANGE: 'swipe.drawer.gameSelected',
  SWIPE_TOPBAR_GAMECHANGE: 'swipe.topbar.gameSelected',

  //MINIGAMES events
  MINI_GAMES_READY: 'mini.ready',
  MINIGAME_COVERCLICK: 'mini.coverClick',
  MINIGAME_LOAD: 'mini.load',
  MINIGAME_ERROR: 'mini.error',
  // Simulate events
  SIMULATE_READY: 'simulate.ready',
  SIMULATE_REFRESHBALANCE: 'simulate.refreshBalance',
  SIMULATE_GAMEANIMATIONSTART: 'simulate.gameAnimationStart',
  SIMULATE_CLOSED: 'simulate.closed',
  SIMULATE_ERROR: 'simulate.error',
  // Simulate Specials events
  SIMULATE_SPECIALS_READY: 'simulateSpecials.ready',
  SIMULATE_SPECIALS_REFRESHBALANCE: 'simulateSpecials.refreshBalance',
  SIMULATE_SPECIALS_CLOSED: 'simulateSpecials.closed',
  SIMULATE_SPECIALS_ERROR: 'simulateSpecials.error',
} as const;

export type EventType = keyof typeof eventType;
export default eventType;
